import Grid from "@mui/material/Grid2";
import { isEmpty } from "lodash";
import { Box } from "@mui/material";

import { TabSessionDataReAuthResponse } from "../../../../models/api/TabSessionStorage";
import { flexRow } from "../../../../styles/mui/styles/display";
import { FieldSpacing } from "../../../PriorAuthWorkFlow/styles/style";
import ReadOnlyField from "../../../../components/FormPriorAuthReAuth/ReadOnlyField";
import { getValue } from "../../../../utils";

export interface PropsFromState {
  tabSessionStorage: TabSessionDataReAuthResponse;
}

type AllProps = PropsFromState;

const PhysicianDetails: React.FC<AllProps> = ({ tabSessionStorage }) => {
  return (
    <Box>
      <Grid container sx={flexRow}>
        {[
          {
            label: "Physician Name:",
            value: getValue(
              tabSessionStorage,
              "response.followingPhysicianDetail.physicianName"
            ),
          },
          {
            label: "NPI:",
            value: getValue(
              tabSessionStorage,
              "response.followingPhysicianDetail.physicianNpiId"
            ),
          },
          {
            label : "Tax ID:",
            value: getValue(
              tabSessionStorage,
              "response.followingPhysicianDetail.taxId"
            )
          },
          {
            label: "Phone:",
            value: `${getValue(
              tabSessionStorage,
              "response.followingPhysicianDetail.phoneNo"
            )} ${
              !isEmpty(
                getValue(
                  tabSessionStorage,
                  "response.followingPhysicianDetail.phoneExt"
                )
              )
                ? "Ext: " +
                  getValue(
                    tabSessionStorage,
                    "response.followingPhysicianDetail.phoneExt"
                  )
                : ""
            }`,
          },
          {
            label: "Fax:",
            value: getValue(
              tabSessionStorage,
              "response.followingPhysicianDetail.fax"
            ),
          },
          {
            label: "Street 1:",
            value: getValue(
              tabSessionStorage,
              "response.followingPhysicianDetail.streetName1"
            ),
          },
          {
            label: "Street 2:",
            value: getValue(
              tabSessionStorage,
              "response.followingPhysicianDetail.streetName2"
            ),
          },
          {
            label: "City:",
            value: getValue(tabSessionStorage, "response.followingPhysicianDetail.city"),
          },
          {
            label: "State:",
            value: getValue(
              tabSessionStorage,
              "response.followingPhysicianDetail.physicianState"
            ),
          },
          {
            label: "County:",
            value: getValue(
              tabSessionStorage,
              "response.followingPhysicianDetail.county"
            ),
          },
          {
            label: "Zipcode:",
            value: getValue(
              tabSessionStorage,
              "response.followingPhysicianDetail.zipCode"
            ),
          },
        ].map(({ label, value }) => (
          <Grid key={label} size={{ xs: 3 }} sx={FieldSpacing}>
            <ReadOnlyField label={label} value={value} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default PhysicianDetails;
